import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/searchengin': {
    width: 460,
    height: 512,
    paths: [
      {
        d: 'M220.6 130.3l-67.2 209.3v-130.3l-54.7 24.2 54.7-190.3v115.3zM137.4 33.6l-1.3 4.7-15.2 52.9c-40.3 15.5-68.9 54.6-68.9 100.3 0 52.3 34.3 95.9 83.4 105.5v53.6c-77.9-10.5-135.4-78.2-135.4-159 0-80.5 59.8-147.2 137.4-158zM448.8 480.8c-11.2 11.2-23.1 12.3-28.6 10.5-5.4-1.8-27.1-19.9-60.4-44.4-33.3-24.6-33.6-35.7-43-56.7-9.4-20.9-30.4-42.6-57.5-52.4l-9.7-14.7c-24.7 16.9-53 26.9-81.3 28.7l2.1-6.6 15.9-49.5c46.5-11.9 80.9-54 80.9-104.2 0-54.5-38.4-102.1-96-107.1v-52.1c83.2 5.1 148.8 74.5 148.8 159.3 0 33.6-11.2 64.7-29 90.4l14.6 9.6c9.8 27.1 31.5 48 52.4 57.4s32.2 9.7 56.8 43c24.6 33.2 42.7 54.9 44.5 60.3 1.8 5.4 0.7 17.3-10.5 28.5zM438.9 462.9c0-4.4-3.6-8-8-8-4.4 0-8 3.6-8 8 0 4.4 3.6 8 8 8 4.4 0 8-3.6 8-8z'
      }
    ]
  }
})
